import angular from 'angular'

import myTable from './tables/myTable'
import myTables from './tables/myTables'
import myDataDisplay from './tables/myDataDisplay'
import mySelectTable from './tables/mySelectTable'
import myModifPosition from './tables/myModifPosition'
import myButton from './buttons/myButton'
import myFloatingButton from './buttons/myFloatingButton'
import myActionButtons from './buttons/myActionButtons'
import myCancelValidateButtons from './buttons/myCancelValidateButtons'
import myLimitHandleButtons from './buttons/myLimitHandleButtons'
import myRadioButton from './buttons/myRadioButton'
import myLoadingBar from './loading/myLoadingBar'
import myLoading from './loading/myLoading'
import myCheckbox from './inputs/myCheckbox'
import myDate from './inputs/myDate'
import myEnter from './inputs/myEnter'
import myField from './inputs/myField'
import myInput from './inputs/myInput'
import mySelect from './inputs/mySelect'
import mySwitch from './inputs/mySwitch'
import myTextArea from './inputs/myTextArea'
import validator from './inputs/validator'
import openSingleModal from './modals/openSingleModal'

import myHomeMenu from './menus/myHomeMenu'
import myRadioMenu from './menus/myRadioMenu'
import myNavBar from './menus/myNavBar'

import backButton from './styles/backButton'
import resizeId from './styles/resizeId'
import resizeLongueur from './styles/resizeLongueur'
import resizePosition from './styles/resizePosition'
import next from './inputs/next'
import mySelectIds from './select/mySelectIds'
import mySelectIdsMove from './select/mySelectIdsMove'

import myTitle from './titles/myTitle'

import myPassword from './inputs/myPassword'
import myNewPassword from './inputs/myNewPassword'
import confirmation from './inputs/confirmation'

import elementsResources from './resources/resource.module'

import compile from './compile.directive'

import myChooseOrder from './tables/myChooseOrder'

import myOwnerPie from './stat/myOwnerPie'
import myMovementsPie from './stat/myMovementsPie'
import myAreaPie from './stat/myAreaPie'

angular.module('elements', [elementsResources,])
  .directive('myTable', myTable)
  .directive('myTables', myTables)
  .directive('myDataDisplay', myDataDisplay)
  .directive('mySelectTable', mySelectTable)
  .directive('myModifPosition', myModifPosition)
  .directive('myButton', myButton)
  .directive('myFloatingButton', myFloatingButton)
  .directive('myActionButtons', myActionButtons)
  .directive('myCancelValidateButtons', myCancelValidateButtons)
  .directive('myLimitHandleButtons', myLimitHandleButtons)
  .directive('myRadioButton', myRadioButton)
  .directive('myLoadingBar', myLoadingBar)
  .directive('myLoading', myLoading)
  .directive('myCheckbox', myCheckbox)
  .directive('myDate', myDate)
  .directive('myEnter', myEnter)
  .directive('myField', myField)
  .directive('myInput', myInput)
  .directive('mySelect', mySelect)
  .directive('mySwitch', mySwitch)
  .directive('myTextArea', myTextArea)
  .directive('validator', validator)
  .directive('openSingleModal', openSingleModal)

  .directive('myHomeMenu', myHomeMenu)
  .directive('myRadioMenu', myRadioMenu)
  .directive('myNavBar', myNavBar)

  .directive('backButton', backButton)
  .directive('labelId', resizeId)
  .directive('labelLongueur', resizeLongueur)
  .directive('labelPosition', resizePosition)
  .directive('next', next.next)
  .directive('nextRevision', next.nextRevision)
  .directive('mySelectIds', mySelectIds)
  .directive('mySelectIdsMove', mySelectIdsMove)

  .directive('myTitle', myTitle)
  .directive('confirmation', confirmation)
  .directive('myPassword', myPassword)
  .directive('myNewPassword', myNewPassword)
  .directive('compile', compile)

  .directive('myChooseOrder', myChooseOrder)

  .directive('myOwnerPie', myOwnerPie)
  .directive('myMovementsPie', myMovementsPie)
  .directive('myAreaPie', myAreaPie)

export default 'elements'



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/elements.module.js